(function () {
  var runtime = window.NulelaSaleTimerRuntime || {
    instances: new WeakMap(),
    listenersBound: false,
  };
  window.NulelaSaleTimerRuntime = runtime;

  function rootsWithin(scope) {
    var container = scope || document;
    var timers = [];

    if (container.matches && container.matches('[data-nulela-sale-timer]')) timers.push(container);
    if (container.querySelectorAll) {
      container.querySelectorAll('[data-nulela-sale-timer]').forEach(function (timer) {
        if (!timers.includes(timer)) timers.push(timer);
      });
    }

    return timers;
  }

  function destroyTimer(timer) {
    var controller = runtime.instances.get(timer);
    if (!controller) return;
    controller.destroy();
    runtime.instances.delete(timer);
  }

  function initTimer(timer) {
    destroyTimer(timer);

    var recurringDaily = timer.getAttribute('data-recurring-daily') === 'true';
    var timeZone = timer.getAttribute('data-time-zone') || 'America/New_York';
    var deadline = recurringDaily ? nextZonedMidnight(Date.now(), timeZone) : Date.parse(timer.getAttribute('data-deadline') || '');
    var visibleWindow = Number(timer.getAttribute('data-visible-window-ms'));
    var remaining = deadline - Date.now();

    if (!recurringDaily) {
      if (!Number.isFinite(deadline) || remaining <= 0 || remaining > visibleWindow) {
        timer.hidden = true;
        return;
      }
    }

    var hours = timer.querySelector('[data-sale-hours]');
    var minutes = timer.querySelector('[data-sale-minutes]');
    var seconds = timer.querySelector('[data-sale-seconds]');
    var interval = null;

    function pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    function stop() {
      if (interval === null) return;
      window.clearInterval(interval);
      interval = null;
    }

    function update() {
      remaining = deadline - Date.now();
      if (recurringDaily && remaining <= 0) {
        var nextTick = Date.now();
        nextTick += 1000;
        deadline = nextZonedMidnight(nextTick, timeZone);
        remaining = deadline - Date.now();
      }
      if (!Number.isFinite(deadline) || remaining <= 0) {
        timer.hidden = true;
        stop();
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      if (hours) hours.textContent = pad(Math.floor(totalSeconds / 3600));
      if (minutes) minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      if (seconds) seconds.textContent = pad(totalSeconds % 60);
      timer.hidden = false;
    }

    runtime.instances.set(timer, {
      destroy: function () {
        stop();
        timer.hidden = true;
      },
    });

    update();
    if (!timer.hidden) interval = window.setInterval(update, 1000);
  }

  function zonedParts(timestamp, timeZone) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date(timestamp));
    var values = {};
    parts.forEach(function (part) { if (part.type !== 'literal') values[part.type] = Number(part.value); });
    return values;
  }

  function zonedOffset(timestamp, timeZone) {
    var parts = zonedParts(timestamp, timeZone);
    var asUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return asUtc - timestamp;
  }

  function nextZonedMidnight(now, timeZone) {
    try {
      var current = zonedParts(now, timeZone);
      var targetWallClock = Date.UTC(current.year, current.month - 1, current.day + 1, 0, 0, 0);
      var guess = targetWallClock - zonedOffset(now, timeZone);
      return targetWallClock - zonedOffset(guess, timeZone);
    } catch (error) {
      var fallback = new Date(now);
      fallback.setUTCHours(24, 0, 0, 0);
      return fallback.getTime();
    }
  }

  function initAll(scope) {
    rootsWithin(scope).forEach(initTimer);
    var campaign = document.querySelector('[data-campaign-name]');
    if (campaign) document.querySelectorAll('[data-nulela-campaign-name]').forEach(function (label) {
      label.textContent = campaign.getAttribute('data-campaign-name');
    });
  }

  function destroyAll(scope) {
    rootsWithin(scope).forEach(destroyTimer);
  }

  function boot() {
    if (runtime.listenersBound) {
      initAll();
      return;
    }
    runtime.listenersBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target); });
  }

  boot();
})();
